import Axios from 'axios';
import { Action, ActionT } from '../../framework/framework/components/Types';
import { ApplicationContext } from '../../framework/framework/shared/ApplicationContext';
import { parseErrors } from '../../framework/framework/tools/parseErrors';
import Emitter from '../eventEmmiter/EventEmmiter';
import { EventTypes } from '../eventEmmiter/EventTypes';
import { IBasketModel } from '../productService/models/IBasketModel';
import { SellActionType } from '../productService/models/SellActionType';
import { IDeliveryData } from './IDeliveryData';

export class BasketService {
    static instance: BasketService;

    static Instance() {
        return BasketService.instance;
    }

    static appCtx: ApplicationContext;

    static init(appCtx: ApplicationContext) {
        BasketService.appCtx = appCtx;
        BasketService.instance = new BasketService();
    }

    axios = Axios;

    get appCtx() { return BasketService.appCtx; }

    onError(error: any) {
        if (error.response.status === 404) {
            if (error.response.data && error.response.data.redirect) {
                const url = this.appCtx.buildUrl(error.response.data.redirect);
                window.location.href = url;
            }
        }
    }

    addToBasket(productId: number, quantity: number) {
        const data = {
            productId: productId,
            quantity: quantity
        };
        const url = this.appCtx.buildUrl('Basket/AddItemToBasket');
        this.axios.post(url, data)
            .then(() => {
                Emitter.emit(EventTypes.Shopping, null);
            })
            .catch(error => { this.onError(error); });
    }

    processOrder(action: SellActionType, onSuccess: Action) {
        this.axios.post(this.appCtx.buildUrl('Basket/ProcessOrder'), { action: action })
            .then(() => {
                Emitter.emit(EventTypes.Shopping, null);
                onSuccess();
            })
            .catch(error => { this.onError(error); });
    }

    updateItem(productId: number, quantity: number, onSucces: ActionT<IBasketModel>) {
        const data = {
            productId: productId,
            quantity: quantity
        };
        const url = this.appCtx.buildUrl('Basket/UpdateItem');
        this.axios.post(url, data)
            .then(response => {
                Emitter.emit(EventTypes.Shopping, () => { });
                onSucces(response.data);
            })
            .catch(error => { this.onError(error); });
    }

    removeItem(productId: number, onSucces: ActionT<IBasketModel>) {
        const data = {
            productId: productId

        };
        const url = this.appCtx.buildUrl('Basket/RemoveItem');
        this.axios.post(url, data)
            .then(response => {
                Emitter.emit(EventTypes.Shopping, {});
                onSucces(response.data);
            })
            .catch(error => { this.onError(error); });
    }

    calculateBasket(action: ActionT<IBasketModel>) {
        const url = this.appCtx.buildUrl('Basket/CalculateBasket');
        this.axios.get(url)
            .then(response => {
                action(response.data);
            })
            .catch(error => { this.onError(error); });
    }

    getDeliveryData(onSuccess: ActionT<IDeliveryData>) {
        const url = this.appCtx.buildUrl('Basket/getOrderDeliveryData');
        this.axios.get(url)
            .then(response => {
                onSuccess(response.data);
            })
            .catch(error => {
                this.onError(error);
            });
    }

    setDeliveryData(deliveryData: IDeliveryData, onSuccess: Action, onError: ActionT<any>) {
        const url = this.appCtx.buildUrl('Basket/SetOrderDeliveryData');
        this.axios.post(url, deliveryData)
            .then(() => {
                onSuccess();
            })
            .catch(error => {
                const data = error.response.data;
                const errors = parseErrors(data);
                onError(errors);
            });
    }
}
